import { useQuery } from '@apollo/client'
import { toAbsoluteUrl } from '../../helpers'
import { GET_BG_ACCOUNT_BY_ID } from '../../graphql/query'
import LoadingSpinner from '../../components/LoadingSpinner'
import LegalInformationPage from '../MultiStepForms/LegalInformationPage'
type Props = {
  formData: any
  setFormData: any
}
export const Step3Page: React.FC<Props> = ({ formData, setFormData }) => {
  const { loading, error, data } = useQuery(GET_BG_ACCOUNT_BY_ID)

  if (loading) {
    return <LoadingSpinner />
  }

  if (error) {
    console.error(error)
  }

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
      style={{
        backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/sketchy-1/14.png')})`
      }}
    >
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        <LegalInformationPage
          loading={loading}
          error={error}
          data={data}
          formData={formData}
          setFormData={setFormData}
        />
      </div>
    </div>
  )
}

export default Step3Page
